import React, {useEffect, useState} from "react";
import {Button, Card, Col, Empty, Row, Tooltip} from "antd";
import * as Setting from "../../conf/Setting";
import i18next from "i18next";
import {InfoCircleTwoTone} from "@ant-design/icons";
import * as IconFont from "../../components/common/IconFont";
import * as SyncerBackend from "../../services/SyncerBackend";
import Sortable from "sortablejs";
import "./SyncerManagement.less";

const SyncerOrderEditPage = (props) => {
  const [upstreamSyncers, setUpstreamSyncers] = useState([]);

  useEffect(() => {
    getSyncer();
  }, []);

  const getSyncer = () => {
    SyncerBackend.getUpstreamSyncerByOwner("")
      .then(res => {
        if (res.status === "ok") {
          const orderList = res.data.sort((a, b) => {return b.order - a.order;});
          setUpstreamSyncers(orderList);
        }
      });
  };

  const getSyncTypeName = (syncType) => {
    const syncTypeObj = Setting.upstreamSyncTypes.find(item => item.id === syncType);
    if (syncTypeObj) {
      return syncTypeObj.name;
    }
    return "";
  };

  const getSyncTypeIcon = (syncType) => {
    switch (syncType) {
    case 0:
      return <IconFont.UserFilledIcon style={{fontSize: 16, color: "#2D78D5", fontWeight: 600}} />;
    case 1:
      return <IconFont.OrganizationFilledIcon style={{fontSize: 16, color: "#13B184", fontWeight: 600}} />;
    case 2:
      return <IconFont.StructureFilledIcon style={{fontSize: 16, color: "#E98C1A", fontWeight: 600}} />;
    case 3:
      return <IconFont.UserRoleIcon style={{fontSize: 16, color: "#E98C1A", fontWeight: 600}} />;
    default:
      return null;
    }
  };

  const sortableGroupDecorator = componentBackingInstance => {
    if (componentBackingInstance) {
      const options = {
        draggable: ".draggable-row",
        filter: "fixed",
        // animation: "150",
        onEnd: evt => {
          let list = [...upstreamSyncers];
          list = list.sort((a, b) => {return b.order - a.order;});
          const oldItem = list[evt.oldIndex];
          const newItem = list[evt.newIndex];
          const newItemOrder = newItem.order;
          if (evt.oldIndex > evt.newIndex) {
            for (let index = evt.newIndex; index < evt.oldIndex; index++) {
              list[index].order = list[index + 1].order;
            }
          } else {
            for (let index = evt.newIndex; index > evt.oldIndex; index--) {
              list[index].order = list[index - 1].order;
            }
          }
          oldItem.order = newItemOrder;
          list.splice(evt.oldIndex, 1);
          list.splice(evt.newIndex, 0, oldItem);
          setUpstreamSyncers(list);
        },
      };
      Sortable.create(componentBackingInstance, options);
    }
  };

  const submitSyncersOrder = (willExit = false) => {
    const newOrderList = upstreamSyncers.map(item => {
      return {
        SyncerUpstreamUid: item.uid,
        Order: item.order,
      };
    });
    SyncerBackend.updateUpstreamSyncerOrder(newOrderList)
      .then(res => {
        if (res.status === "ok") {
          Setting.showMessage("success", i18next.t("general:Successfully saved"));
          if (willExit) {
            props.history.push("/syncers");
          }
        } else {
          Setting.showResponseMessage(res.msg);
        }
      }).catch(error => {
        Setting.showMessage("error", `${error}`);
      });
  };

  const renderCard = (syncer) => {
    return (
      <Col className="draggable-row" key={syncer.uid} style={{paddingLeft: "12px", paddingRight: "12px", paddingBottom: "20px"}} span={6}>
        <Card
          className="syncer-card"
          hoverable
          onClick={() => {
          }}
        >
          <div style={{paddingLeft: 17, marginBottom: 20, display: "flex", justifyContent: "space-between", position: "relative"}}>
            <img style={{position: "absolute", left: 0, top: 0}} src={require("../../assets/images/syncer/rect.png")} />
            <div style={{width: "calc(100% - 88px)", display: "flex"}}>
              <div title={syncer.displayName}
                style={{overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap", maxWidth: "calc(100% - 60px)", fontSize: 14, fontWeight: 600, color: "rgba(0, 0, 0, 0.85)"}}>
                {syncer.displayName}
              </div>
              {
                !syncer.isEnabled ?
                  <span style={{marginLeft: 8, backgroundColor: "#D4D4D4", width: 58, fontSize: 12, padding: "2px 8px", borderRadius: 50, textAlign: "center", color: "rgba(0, 0, 0, 0.45)"}}>
                    {i18next.t("syncer:Disabled")}
                  </span>
                  :
                  null
              }
            </div>
            <div style={{marginRight: 10, color: "rgba(0, 0, 0, 0.45)"}}>
              <img src={require("../../assets/images/syncer/diamond.png")} style={{marginRight: 3}} />
              {i18next.t("syncer:Priority")}
              {syncer.order}
            </div>
          </div>
          <div style={{height: 32, paddingLeft: 17, display: "flex", justifyContent: "space-between", alignItems: "center"}}>
            <div style={{color: "rgba(0, 0, 0, 0.65)"}}>
              {
                getSyncTypeIcon(syncer.syncType)
              }
              &nbsp;&nbsp;
              {
                getSyncTypeName(syncer.syncType)
              }
              <Tooltip placement="top" title={getSyncTypeName(syncer.syncType)}>
                <InfoCircleTwoTone twoToneColor="rgb(45, 120, 213)" style={{marginLeft: 4}} />
              </Tooltip>
            </div>
          </div>
        </Card>
      </Col>
    );
  };

  return <>
    <div style={{marginTop: "20px", marginLeft: "40px"}}>
      <Button onClick={() => submitSyncersOrder(false)}>{i18next.t("general:Save")}</Button>
      <Button style={{marginLeft: "20px"}} type="primary" onClick={() => submitSyncersOrder(true)}>{i18next.t("general:Save & Exit")}</Button>
      <Button style={{marginLeft: "20px"}} onClick={() => props.history.goBack()}>{i18next.t("general:Cancel")}</Button>
    </div>
    <div style={{marginRight: "15px", marginLeft: "15px"}}>
      {
        upstreamSyncers.length > 0 ?
          <Row ref={sortableGroupDecorator} justify="flex-start" style={{marginLeft: "-20px", marginRight: "-20px", marginTop: "20px"}} gutter={24}>
            {
              upstreamSyncers.map((syncer, index) => renderCard(syncer))
            }
          </Row>
          :
          <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
      }
    </div>
  </>;
};

export default SyncerOrderEditPage;
